import { useState, useEffect } from 'react';

const testimonials = [
  {
    quote: `BLING works to promote diversity and inclusion in the Swedish business community and innovation system. We look forward to contributing to Sweden Startup Nation. Collected data will provide us with better tools to highlight and support startups from underrepresented groups.`,
    name: 'Deqa Abukar',
    title: 'Founder of BLING',
    img: '',
  },
  {
    quote: `In Sweden, we have world-leading research in several areas and we top various rankings, for example in terms of the number of high-quality patents. However, we could become even better at commercialising and starting more successful growth companies to bring this research to society in a scalable way, where it creates real value. By collecting data on companies coming from universities, we can better understand their challenges and gain insights that will increase the proportion of research-based startups that make the entire journey from lab to scaleup.`,
    name: 'Niclas Nilsson',
    title: `Innovation Director at LU Innovation at Lund University, representative for Sweden's University Innovation Offices`,
    img: '',
  },
  {
    quote: `Through Sweden Startup Nation, we are creating a unified platform to generate and spread knowledge about startups and scaleups from across the country, as well as insights into what is required for them to get the best conditions to grow in Sweden. This will not only benefit the entrepreneurs but also strengthen Sweden's position as a leading innovation nation. We also welcome other actors with similar goals to get in touch to explore collaboration opportunities and together create even greater impact.`,
    name: 'Ulrika Malmqvist',
    title: 'Chair of SISP and CEO of Movexum in Gävle',
    img: '',
  },
  {
    quote: `Sweden lacks an independent national organisation that continuously collects and presents data on how we as a nation perform regarding startups and scaleups, something we see other countries doing successfully. To strengthen our competitiveness, we must work more data-driven and by linking data with insights from the innovation ecosystem, we can improve how we support startups and scaleups during their critical growth journeys.`,
    name: 'Lisa Ericsson',
    title: 'CEO KTH Holding and representative for FUHS in the project',
    img: '',
  },
];

const TestimonialsSectionSv = () => {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(c => (c + 1) % testimonials.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  const t = testimonials[current];
  return (
    <section className="py-24 bg-gray-50">
      <div className="w-full px-8 md:px-16 lg:px-24">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-16 animate-on-scroll">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-gray-900">Vad våra partners säger</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Röster från det svenska innovationsekosystemet
            </p>
          </div>
          <div className="bg-white rounded-3xl shadow-xl p-10 flex flex-col items-center transition-all duration-700 h-[500px]">
            <div className="flex flex-col items-center h-full w-full justify-between flex-1">
              <p className="text-lg text-gray-800 italic text-center max-w-2xl flex-1 flex items-center justify-center mb-8">"{t?.quote}"</p>
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 rounded-full bg-gray-200 overflow-hidden flex items-center justify-center mb-4">
                  {/* Place for image: <img src={t?.img} alt={t?.name} className="w-full h-full object-cover" /> */}
                </div>
                <div className="text-center">
                  <div className="font-bold text-gray-900 text-lg">{t?.name}</div>
                  <div className="text-gray-500 text-sm">{t?.title}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSectionSv;
